import { z } from 'zod';
import type { TFunction } from 'i18next';

const editBankAddressFormSchema = (t: TFunction) => {
  const required = t('common.requiredField');

  return z.object({
    templateName: z.string().nonempty({ message: required }),
  });
};

export { editBankAddressFormSchema };
